import { postAjax, toggle, disableSendButton } from './functions'

import { siblings } from './Vue/functions/getSiblings'

document.addEventListener( 'DOMContentLoaded', function () {
    const viewportWidth = window.innerWidth

    const deliveriesCart = document.querySelectorAll('.js-cart-delivery-step')
    const paymentsCart   = document.querySelectorAll('.js-cart-payment-step')

    if ( deliveriesCart && paymentsCart ) {

        deliveriesCart.forEach( delivery => {
            delivery.addEventListener('click', function (e) {
                let payments = JSON.parse(this.getAttribute('data-allowed-payments'))

                if ( !this.getAttribute('data-canceled') ) {
                    paymentsCart.forEach( payment => {

                        payment.setAttribute('data-canceled', true)
                        payment.children[0].checked = false

                        if ( !payments.includes(payment.getAttribute('data-id')) )
                            payment.style.display = 'none'
                        else
                            payment.style.display = 'inline-flex'
                    })
                }
                $('.custom-checkbox').css('width', '100%')
            })
        })

        paymentsCart.forEach( payment => {
            payment.addEventListener('click', function (e) {
                let id = this.getAttribute('data-id')

                if ( !this.getAttribute('data-canceled') ) {
                    deliveriesCart.forEach( delivery => {
                        delivery.setAttribute('data-canceled', true)
                        delivery.checked = false
                        let payments = JSON.parse(delivery.getAttribute('data-allowed-payments'))

                        if ( payments.includes(id) )
                            delivery.style.display = 'inline-flex'
                        else
                            delivery.style.display = 'none'
                    })
                }
                $('.custom-checkbox').css('width', '100%')
            })
        })
    }

    const hamburger = document.querySelector('.js-hamburger')
    const mobileMenu = document.querySelector('.js-mobile-menu')
    console.log()

    //     mobileMenu.find('.js-arrow').on('click', function () {
//         $(this).siblings('.submenu').toggle();
//     });
//

    if ( hamburger ) {

        hamburger.addEventListener('click', function (e) {
            e.preventDefault()
            this.classList.toggle('open')
            toggle(mobileMenu)
        })

        const expands = mobileMenu.querySelectorAll('.js-arrow')

        if ( expands ) {

            expands.forEach( expand => {
                expand.addEventListener('click', function () {
                    toggle(this.nextElementSibling)
                })
            })
        }
    }

    const promoSlider = document.querySelector('.js-promo-slider')

    if ( promoSlider ) {

        new Splide(promoSlider, {
            type      : 'loop',
            perPage   : 1,
            focus     : 'center',
            autoWidth : true,
            //width     : '90%',
            pagination: true,
            }).mount();
    }

    const productCategoryTabs = document.querySelectorAll('.js-category-tabs a')
    const productSlider       = document.querySelectorAll('.js-product-slider')

    if ( productCategoryTabs ) {

        const setActive = el => {
            [...el.parentElement.children].forEach(sib => sib.classList.remove('active'))

            el.classList.add('active')
        }

        productCategoryTabs.forEach( (tab, index) => {

            tab.addEventListener('click', function (e) {
                e.preventDefault()

                setActive(tab)

                let catId = this.getAttribute('data-cat');

                productSlider.forEach( (slider, index) => {
                    slider.style.display = 'none'
                })

                document.querySelector('.js-product-slider[data-cat="'+ catId +'"]')
                    .style.display = 'block'
            })
        })
    }

    if ( productSlider ) {

        productSlider.forEach( (slider, index) => {

            let productSliderTemp;

            let productsIds = JSON.parse(slider.getAttribute('data-products'))

            postAjax('/api/frontend/products', {
                sliderItem: true,
                productsIds: productsIds
            }, function (data) {

                slider.innerHTML = JSON.parse(data).products

                let perPage = 4

                if ( productsIds.length < 4 )
                    perPage = productsIds.length

               new Splide(slider, {
                    perPage   : perPage,
                    pagination: true,
                    gap       : '32px',
                    padding   : {
                        left  : 15,
                        right : 15
                    },
                   breakpoints: {
                        991: {
                            perPage: 3
                        },
                       767: {
                            perPage: 2
                       },
                       575: {
                            perPage: 1,
                            focus: 'center'
                       }
                   }
                }).on('mounted', function () {
                   setElHeight(document.querySelectorAll('.product .text h3'))
               }).mount()

                if ( index !== 0 ) slider.style.display = 'none'
            })
        })
    }

    function setElHeight(el) {
        let maxHeight = 0

        el.forEach( item => {
            if ( item.clientHeight > maxHeight )
                maxHeight = item.clientHeight
        })

        el.forEach( item => {
            item.style.height = maxHeight + 'px'
        })
    }

    const jsCategoriesBlock = document.querySelector('.js-categories-block')

    if ( jsCategoriesBlock ) {

        let catIds = JSON.parse(jsCategoriesBlock.getAttribute('data-categories'))

        postAjax('/api/frontend/categories', {
            catIds: catIds
        }, function (data) {
            jsCategoriesBlock.innerHTML = JSON.parse(data).categories
        })
    }

    const partnerSlider = document.querySelector('.js-partner-slider')

    if ( partnerSlider ) {

        new Splide(partnerSlider, {
            type        : 'loop',
            perPage     : 6,
            perMove     : 1,
            autoplay    : true,
            arrows      : false,
            interval    : 4000,
            pauseOnHover: false,
            gap         : '32px',
            pagination  : false,
            breakpoints : {
                991: {
                    perPage: 4
                },
                767: {
                    perPage: 3
                },
                575: {
                    perPage: 2
                }
            }
        }).mount()
    }

    const profileDeliveryAddress = document.querySelector('section.profile .delivery-address .title')

    if ( profileDeliveryAddress ) {

        profileDeliveryAddress.addEventListener('click', function () {
            this.classList.toggle('active')
            toggle(this.nextElementSibling)
        })
    }

    const cartDeliveryAddressChecker = document.getElementById('delivery-address-input')

    if ( cartDeliveryAddressChecker ) {

        if ( !cartDeliveryAddressChecker.checked )
            document.querySelector('.js-delivery').classList.add('active')

        cartDeliveryAddressChecker.addEventListener('change', function () {
            if ( this.checked ) {
                document.querySelector('.js-delivery').classList.remove('active')
            } else {
                document.querySelector('.js-delivery').classList.add('active')
            }
        })
    }

    const submitOrder = document.getElementById('js-submit-order')

    if ( submitOrder ) {

        submitOrder.addEventListener('click', function (e) {
            document.querySelector('.js-loader').classList.add('visible')
        })
    }

    const flashMessage = document.querySelectorAll('.js-flash-message')

    if ( flashMessage ) {

        flashMessage.forEach( alert => {

            setTimeout( () => {
                alert.remove()
            }, 3000)
        })
    }

    const scrollToElements = document.querySelectorAll('.js-scroll')

    if ( scrollToElements ) {

        scrollToElements.forEach( (el, index) => {

            el.addEventListener('click', function (e) {
                e.preventDefault()

                document.getElementById(this.getAttribute('href').replace('#', ''))
                    .scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    })
            })
        })
    }

    const layoutSwitch = document.querySelectorAll('.js-layout-switch')

    if ( layoutSwitch ) {

        layoutSwitch.forEach( (item, index) => {
            item.addEventListener('click', function () {
                let target = item.getAttribute('data-layout')

                siblings(item).forEach( sibling => sibling.classList.remove('active'))

                item.classList.add('active')

                document.querySelectorAll('.product-listing-wrapper')
                    .forEach( (item, index) => {
                        item.style.display = 'none'
                    })

                document.getElementById(target).style.display = 'block'
            })
        })
    }

    const listingToggleFilter = document.querySelector('.js-show-filter-el')

    if ( listingToggleFilter ) {

        listingToggleFilter.addEventListener('click', function () {
            toggle(document.querySelector('aside.filter'))
        })
    }

    const profileOrders = document.querySelectorAll('.js-orders-list .item')

    if ( profileOrders ) {

        profileOrders.forEach( order => {
            order.addEventListener('click', function () {
                this.classList.toggle('open')
                toggle(this.children[1])
            })
        })
    }

    const detailMainSlider      = document.querySelector('.js-detail-main-slider')
    const detailThumbnailSlider = document.querySelector('.js-detail-thumbnail-slider')

    if ( detailMainSlider && detailThumbnailSlider ) {

        // console.log(detailMainSlider, detailThumbnailSlider)

        let mainSlider = new Splide(detailMainSlider, {
            arrows    :  true,
            pagination:  false
        })

        let thumbnails = new Splide(detailThumbnailSlider, {
            perPage     : 5,
            arrows      : false,
            isNavigation: true,
            pagination  : false,
            gap         : '22px',
            breakpoints: {
                767: {
                    perPage: 4
                },
                567: {
                    perPage: 3
                }
            }
        })

        mainSlider.sync(thumbnails)
        mainSlider.mount()
        thumbnails.mount()
    }


    // Function to binding dynamic elements for add to cart
    document.addEventListener('click', function (e) {

        if ( e.target && e.target.classList.contains('js-add-to-cart') ) {
            e.preventDefault()
            e.stopImmediatePropagation()

            let productId = e.target.getAttribute('data-id')
            let targetUrl = e.target.getAttribute('data-url')

            postAjax(targetUrl, { id: productId, quantity: 1}, function(data) {
                let parseData = JSON.parse(data)

                document.getElementById('js-basket').setAttribute('data-basket-count', parseInt(parseData.quantity))
                //document.getElementById('js-cart-total').innerHTML =  parseInt(parseData.totalPrice)

                document.getElementById('popup-wrap').innerHTML = parseData.popup
            })
        }

        if ( e.target && e.target.classList.contains('js-close-popup') ) {
            e.preventDefault()
            e.stopImmediatePropagation()

            document.getElementById('product-modal').remove()
        }
    });

    const submitCard = document.getElementById('submit-cart');

    if(submitCard){
        submitCard.onsubmit = function(event) {
            disableSendButton();
        }
    }
})


// $(document).ready( function() {
//
//     let aboutListItems = $('.js-list-item');
//
//     if ( aboutListItems.length ) {
//
//         aboutListItems.on('click', function () {
//             let self = $(this);
//
//            self.siblings('.content').toggle();
//            self.find('.js-minus').toggle();
//            self.find('.js-plus').toggle();
//         });
//     }
//     let addressHandler = $('.js-address input');
//
//     if ( addressHandler.length ) {
//
//         addressHandler.change( function () {
//            if ( !$(this).is(':checked') )
//                $('.delivery-wrapper').show();
//            else
//                $('.delivery-wrapper').hide();
//         });
//     }
//
//     /* let quantityInput = $('.spinner');
//
//     if ( quantityInput.length ) {
//
//         $('.spinner .plus').click( function (e) {
//             e.preventDefault();
//
//             let input = $(this).prev().prev();
//
//             input.val(parseInt(input.val()) + 1);
//         });
//
//         $('.spinner .minus').click( function (e) {
//             e.preventDefault();
//
//             let input = $(this).next();
//             if  ( input.val() > 1 ) input.val(parseInt(input.val()) - 1);
//         });
//     } */
//
//     let scrollLinks = $('.js-scroll');
//
//     if ( scrollLinks.length ) {
//
//         scrollLinks.on('click', function () {
//             let target = $(this).attr('href');
//
//             $('html, body').stop().animate({
//                 'scrollTop': $(target).offset().top - 50
//             }, 500);
//         });
//     }
//     let showMoreText = $('.js-more-text');
//
//     if ( showMoreText.length ) {
//         showMoreText.on('click', function () {
//             $(this).hide();
//             $('.more-text').show();
//         });
//     }
//
//     let editAddress = $('.js-edit-address');
//
//     if ( editAddress.length ) {
//
//         editAddress.on('click', function () {
//            let target = $(this).attr('data-form');
//
//            $('div[data-form]').hide();
//            $('div[data-form="'+ target +'"]').show();
//         });
//     }
// });
